import React, { useState } from "react";
import { Fragment } from "react";
import { useEventHistory } from "../../../common/hooks/useEventHistory";
import { ROLES } from "../../../Config/helpers/constants";
import { useSelector } from "react-redux";
import { PROFILE } from "../../../Store/Features/ProfileSlice";
import Loader from "../../../common/cards/Loader";
import { useParams } from "react-router-dom";
import EventHistoryCard from "../../../common/EventHistroy/EventHistoryCard";
import TimelineDot from "../../../common/EventHistroy/TimelineDot";
import "../../../common/EventHistroy/EventHistoryCard.css";
import { Button, Grid, Timeline } from "antd";
import { KEYS } from "../../../Config/Keys";

function PlayerEventHistory({ current }) {
  const [active, setActive] = useState("allevents");
  const userDetails = useSelector(PROFILE);
  const { id } = useParams();

  const { historyLoading, historyData } = useEventHistory(
    current ?? ROLES.player,
    id ?? userDetails?._id
  );

  const { useBreakpoint } = Grid;
  const breakpoints = useBreakpoint();

  const filterEvents = () => {
    if (active === "allevents") {
      return historyData; // All events
    } else if (active === "awards") {
      // Only events that are ended and have awards
      return historyData.filter((event) => {
        const currentDate = new Date();
        const endDate = new Date(event?.endDate);
        return endDate < currentDate && event?.awards?.length > 0; // Check for ended events with awards
      });
    }
    return [];
  };

  return (
    <Fragment>
      <div style={{ display: "flex", justifyContent: "center", columnGap: "2rem", margin: "2rem" }}>
        <Button
          className="eventhistory-action-btn"
          type={active === "allevents" ? "primary" : "default"}
          shape="round"
          size="large"
          onClick={() => setActive("allevents")}>
          Event History
        </Button>
        <Button
          className="eventhistory-action-btn"
          type={active === "awards" ? "primary" : "default"}
          shape="round"
          size="large"
          onClick={() => setActive("awards")}>
          Awards Shelf
        </Button>
      </div>
      {historyLoading ? (
        <Loader />
      ) : filterEvents()?.length > 0 ? (
        <div className="event-history-wrapper">
          {breakpoints?.md ? (
            <Timeline mode={breakpoints.md ? "alternate" : "left"}>
              {filterEvents()
                ?.reverse()
                ?.map((event, index) => (
                  <Timeline.Item
                    key={index}
                    dot={
                      <TimelineDot
                        img={
                          event?.file?.fileUrl
                            ? KEYS.API + event?.file?.fileUrl
                            : KEYS.API + event?.eventFile?.fileUrl
                        }
                      />
                    }>
                    <EventHistoryCard
                      data={event}
                      index={index + 1}
                      historyFor={current ?? ROLES.player}
                    />
                  </Timeline.Item>
                ))}
            </Timeline>
          ) : (
            filterEvents().map((event, index) => (
              <EventHistoryCard
                key={index}
                index={index + 1}
                data={event}
                historyFor={current ?? ROLES.player}
              />
            ))
          )}
        </div>
      ) : (
        <h3 style={{ textAlign: "center" }}>Event History Not Found</h3>
      )}
    </Fragment>
  );
}

export default PlayerEventHistory;
